import React, { useState, useEffect } from "react";

import MenuItem from "@mui/material/MenuItem";
import { useLocation, useNavigate } from "react-router-dom";
import { Box, ListItemText, MenuList, Paper } from "@mui/material";
import Collapse from "@mui/material/Collapse";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import PersonIcon from "@mui/icons-material/Person";
import MenuIcon from "@mui/icons-material/Menu";
import FaceIcon from "@mui/icons-material/Face";
import CheckIcon from "@mui/icons-material/Check";

const MenuPage = (props:any) => {

  const loc = useLocation()
  // console.log('loc', loc.pathname.split('/').reverse()[0])

  const [selectedItem, setSelectedItem] = useState(loc.pathname.split('/').reverse()[0]);
  // setSelectedItem();

  const handleMenuItemClick = (
    event: React.MouseEvent<HTMLLIElement>,
    index: number
  ) => {
    setSelectedItem("");
  };

  const [menu01, setMenu01] = React.useState(false);

  const ClickMenu01 = () => {
    setMenu01(!menu01);
  };

  const [menu02, setMenu02] = React.useState(false);

  const ClickMenu02 = () => {
    setMenu02(!menu02);
  };

  const [menu03, setMenu03] = React.useState(false);

  const ClickMenu03 = () => {
    setMenu03(!menu03);
  };

  const [menu04, setMenu04] = React.useState(false);

  const ClickMenu04 = () => {
    setMenu04(!menu04);
  };

  


  var nav = useNavigate();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  // const goMain = () => {
  //   // window.location.href = "/admin/hrm/list";
  //   nav("/admin/hrm/list");
  // };

  // const hanwool = () => {
  //   nav("/admin/hrm/hanwool");
  // };

  // const wools = () => {
  //   nav("/admin/hrm/wools");
  // };

  const upload_test = () => {
    nav("/admin/hrm/upload")
  }
  
  const tree = () => {
    nav("/admin/hrm/tree")
  }

  const selectDefaultItem =()=>{
    
  }

  useEffect(()=> {
    // console.log('selectedItem',selectedItem)
    if(['dialogSample','soundSample','noiseSample'].includes(selectedItem)){
      // console.log('selectedItem',selectedItem)
      setMenu01(true)
    }
    else if(['memberAssignment','nvScriptList','scriptFileList','fixDataForTta'].includes(selectedItem)){
      setMenu02(true)
    }else if(['memberContract','workerToManager','memberList','scriptFileStatus','orgStatus','scriptConfirmStatus','scriptConfirmAssignment','cms'].includes(selectedItem)){
      setMenu03(true)
    }else{
      setMenu04(true)
    }
    
  },[])

  return (
    <Box
      sx={{ width: "300px", borderRight:"4px solid #eee" }}
    >
      <Box sx={{ padding: 4 }}>
        <MenuList>

          <MenuItem onClick={ClickMenu01} >
            <ListItemText><Box sx={{fontWeight:700, fontSize:"20px"}}>샘플 관리</Box></ListItemText>
            {open ? <ExpandLess /> : <ExpandMore />}
          </MenuItem>

          <Collapse in={menu01} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {["ADMIN","MANAGER","WORKER_DIALOG"].includes(props.pageRole) ?
              <ListItemButton
                selected={selectedItem === "dialogSample"}
                sx={{ pl: 4, fontSize:"8px" }}
                onClick={() => { setSelectedItem("dialogSample");  setMenu02(false); setMenu03(false); setMenu04(false); nav("/admin/hrm/dialogSample");}}
              >
                <ListItemText
                  primary={<Box sx={{fontWeight:700, fontSize:"14px"}}>대화 - 샘플 현황</Box>}
                  // onClick={() => nav("/admin/hrm/dialogSample")}
                />
                <ListItemIcon>
                  {selectedItem === "dialogSample" ? <CheckIcon htmlColor="#0000FF" /> : null}
                </ListItemIcon>
              </ListItemButton>
              :""}

              {["ADMIN","MANAGER","WORKER_SOUND"].includes(props.pageRole) ?
              <ListItemButton
                selected={selectedItem === "soundSample"}
                sx={{ pl: 4, fontSize:"8px" }}
                onClick={() => { setSelectedItem("soundSample");  setMenu02(false); setMenu03(false); setMenu04(false); nav("/admin/hrm/soundSample"); }}
              >
                <ListItemText
                  primary={<Box sx={{fontWeight:700, fontSize:"14px"}}>소리 - 샘플 현황</Box>}
                  // onClick={() => }
                />
                <ListItemIcon>
                  {selectedItem === "soundSample" ? <CheckIcon htmlColor="#0000FF" /> : null}
                </ListItemIcon>
              </ListItemButton>
              :""}

              {["ADMIN","MANAGER","WORKER_NOISE"].includes(props.pageRole) ?
              <ListItemButton
                selected={selectedItem === "noiseSample"}
                sx={{ pl: 4, fontSize:"8px" }}
                onClick={() => { setSelectedItem("noiseSample");  setMenu02(false); setMenu03(false); setMenu04(false); nav("/admin/hrm/noiseSample");}}
              >
                <ListItemText
                  primary={<Box sx={{fontWeight:700, fontSize:"14px"}}>소음 - 샘플 현황</Box>}
                  // onClick={() => }
                />
                <ListItemIcon>
                  {selectedItem === "noiseSample" ? <CheckIcon htmlColor="#0000FF" /> : null}
                </ListItemIcon>
              </ListItemButton>
              :""}
              
            </List>
          </Collapse>

          {["ADMIN","MANAGER","WORKER_DIALOG"].includes(props.pageRole) ?
          <Box>
            <MenuItem onClick={ClickMenu04} sx={{marginTop:2}}>
              <ListItemText><Box sx={{fontWeight:700, fontSize:"20px"}}>수집 관리</Box></ListItemText>
              {open ? <ExpandLess /> : <ExpandMore />}
            </MenuItem>

            <Collapse in={menu04} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>

              <ListItemButton
                  selected={selectedItem === "dialogOrg"}
                  sx={{ pl: 4, fontSize:"8px" }}
                  onClick={() => { setSelectedItem("dialogOrg");  setMenu01(false); setMenu02(false); setMenu03(false); nav("/admin/hrm/dialogOrg"); }}
                >
                <ListItemText
                  primary={<Box sx={{fontWeight:700, fontSize:"14px"}}>대화 - 수집</Box>}
                  // onClick={() => }
                />
                <ListItemIcon>
                  {selectedItem === "dialogOrg" ? <CheckIcon htmlColor="#0000FF" /> : null}
                </ListItemIcon>
              </ListItemButton>


              {["ADMIN"].includes(props.pageRole) && 
                <ListItemButton
                    selected={selectedItem === "dialogCountState"}
                    sx={{ pl: 4, fontSize:"8px" }}
                    onClick={() => { setSelectedItem("dialogCountState");  setMenu01(false); setMenu02(false); setMenu03(false); nav("/admin/hrm/dialogCountState"); }}
                  >
                  <ListItemText
                    primary={<Box sx={{fontWeight:700, fontSize:"14px"}}>대화 - 수집 현황</Box>}
                    // onClick={() => }
                  />
                  <ListItemIcon>
                    {selectedItem === "dialogCountState" ? <CheckIcon htmlColor="#0000FF" /> : null}
                  </ListItemIcon>
                </ListItemButton>

              }

              <ListItemButton
                  selected={selectedItem === "dialogOrgReUploadSttSrt"}
                  sx={{ pl: 4, fontSize:"8px" }}
                  onClick={() => { setSelectedItem("dialogOrgReUploadSttSrt");  setMenu01(false); setMenu02(false); setMenu03(false); nav("/admin/hrm/dialogOrgReUploadSttSrt"); }}
                >
                <ListItemText
                  primary={<Box sx={{fontWeight:700, fontSize:"14px"}}>SRT 재업로드</Box>}
                  // onClick={() => }
                />
                <ListItemIcon>
                  {selectedItem === "dialogOrgReUploadSttSrt" ? <CheckIcon htmlColor="#0000FF" /> : null}
                </ListItemIcon>
              </ListItemButton>

              </List>
            </Collapse>
          </Box>
          :""}

          {["ADMIN","MANAGER"].includes(props.pageRole) ?
          <Box>
            <MenuItem onClick={ClickMenu02} sx={{marginTop:2}}>
              <ListItemText><Box sx={{fontWeight:700, fontSize:"20px"}}>작업 관리</Box></ListItemText>
              {open ? <ExpandLess /> : <ExpandMore />}
            </MenuItem>

            <Collapse in={menu02} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>

              <ListItemButton
                  selected={selectedItem === "memberAssignment"}
                  sx={{ pl: 4, fontSize:"8px" }}
                  onClick={() => { setSelectedItem("memberAssignment");  setMenu01(false); setMenu03(false); setMenu04(false); nav("/admin/hrm/memberAssignment"); }}
                >
                <ListItemText
                  primary={<Box sx={{fontWeight:700, fontSize:"14px"}}>대화 작업 할당</Box>}
                  // onClick={() => }
                />
                <ListItemIcon>
                  {selectedItem === "memberAssignment" ? <CheckIcon htmlColor="#0000FF" /> : null}
                </ListItemIcon>
              </ListItemButton>

              <ListItemButton
                  selected={selectedItem === "nvScriptList"}
                  sx={{ pl: 4, fontSize:"8px" }}
                  onClick={() => { setSelectedItem("nvScriptList");  setMenu01(false); setMenu03(false); setMenu04(false); nav("/admin/hrm/nvScriptList"); }}
                >
                <ListItemText
                  primary={<Box sx={{fontWeight:700, fontSize:"14px"}}>녹음대상 스크립트 관리</Box>}
                  // onClick={() => }
                />
                <ListItemIcon>
                  {selectedItem === "nvScriptList" ? <CheckIcon htmlColor="#0000FF" /> : null}
                </ListItemIcon>
              </ListItemButton>

              <ListItemButton
                  selected={selectedItem === "scriptFileList"}
                  sx={{ pl: 4, fontSize:"8px" }}
                  onClick={() => { setSelectedItem("scriptFileList");  setMenu01(false); setMenu03(false); setMenu04(false); nav("/admin/hrm/scriptFileList"); }}
                >
                <ListItemText
                  primary={<Box sx={{fontWeight:700, fontSize:"14px"}}>제출 스크립트 관리</Box>}
                  // onClick={() => }
                />
                <ListItemIcon>
                  {selectedItem === "scriptFileList" ? <CheckIcon htmlColor="#0000FF" /> : null}
                </ListItemIcon>
              </ListItemButton>

              <ListItemButton
                  selected={selectedItem === "fixDataForTta"}
                  sx={{ pl: 4, fontSize:"8px" }}
                  onClick={() => { setSelectedItem("fixDataForTta");  setMenu01(false); setMenu03(false); setMenu04(false); nav("/admin/hrm/fixDataForTta"); }}
                >
                <ListItemText
                  primary={<Box sx={{fontWeight:700, fontSize:"14px"}}>TTA 데이터 수정</Box>}
                  // onClick={() => }
                />
                <ListItemIcon>
                  {selectedItem === "fixDataForTta" ? <CheckIcon htmlColor="#0000FF" /> : null}
                </ListItemIcon>
              </ListItemButton>

              </List>
            </Collapse>
          </Box>
          :""}

          {props.pageRole == "ADMIN" ?
          <Box>
            <MenuItem onClick={ClickMenu03} sx={{marginTop:2}}>
              <ListItemText><Box sx={{fontWeight:700, fontSize:"20px"}}>인사 관리</Box></ListItemText>
              {open ? <ExpandLess /> : <ExpandMore />}
            </MenuItem>

            <Collapse in={menu03} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>

              <ListItemButton
                  selected={selectedItem === "memberContract"}
                  sx={{ pl: 4, fontSize:"8px" }}
                  onClick={() => { setSelectedItem("memberContract");  setMenu01(false); setMenu02(false); setMenu04(false); nav("/admin/hrm/memberContract"); }}
                >
                <ListItemText
                  primary={<Box sx={{fontWeight:700, fontSize:"14px"}}>회원 계약 정보</Box>}
                  // onClick={() => }
                />
                <ListItemIcon>
                  {selectedItem === "memberContract" ? <CheckIcon htmlColor="#0000FF" /> : null}
                </ListItemIcon>
              </ListItemButton>

              <ListItemButton
                  selected={selectedItem === "workerToManager"}
                  sx={{ pl: 4, fontSize:"8px" }}
                  onClick={() => { setSelectedItem("workerToManager");  setMenu01(false); setMenu02(false); setMenu04(false); nav("/admin/hrm/workerToManager"); }}
                >
                <ListItemText
                  primary={<Box sx={{fontWeight:700, fontSize:"14px"}}>중간관리자 인력 배분</Box>}
                  // onClick={() => }
                />
                <ListItemIcon>
                  {selectedItem === "workerToManager" ? <CheckIcon htmlColor="#0000FF" /> : null}
                </ListItemIcon>
              </ListItemButton>

              <ListItemButton
                  selected={selectedItem === "memberList"}
                  sx={{ pl: 4, fontSize:"8px" }}
                  onClick={() => { setSelectedItem("memberList");  setMenu01(false); setMenu02(false); setMenu04(false); nav("/admin/hrm/memberList"); }}
                >
                <ListItemText
                  primary={<Box sx={{fontWeight:700, fontSize:"14px"}}>회원 정보</Box>}
                  // onClick={() => }
                />
                <ListItemIcon>
                  {selectedItem === "memberList" ? <CheckIcon htmlColor="#0000FF" /> : null}
                </ListItemIcon>
              </ListItemButton>

              <ListItemButton
                  selected={selectedItem === "scriptFileStatus"}
                  sx={{ pl: 4, fontSize:"8px" }}
                  onClick={() => { setSelectedItem("scriptFileStatus");  setMenu01(false); setMenu02(false); setMenu04(false); nav("/admin/hrm/scriptFileStatus"); }}
                >
                <ListItemText
                  primary={<Box sx={{fontWeight:700, fontSize:"14px"}}>금액 - 스크립트</Box>}
                  // onClick={() => }
                />
                <ListItemIcon>
                  {selectedItem === "scriptFileStatus" ? <CheckIcon htmlColor="#0000FF" /> : null}
                </ListItemIcon>
              </ListItemButton>

              <ListItemButton
                  selected={selectedItem === "orgStatus"}
                  sx={{ pl: 4, fontSize:"8px" }}
                  onClick={() => { setSelectedItem("orgStatus");  setMenu01(false); setMenu02(false); setMenu04(false); nav("/admin/hrm/orgStatus"); }}
                >
                <ListItemText
                  primary={<Box sx={{fontWeight:700, fontSize:"14px"}}>금액 - 대화음성</Box>}
                  // onClick={() => }
                />
                <ListItemIcon>
                  {selectedItem === "orgStatus" ? <CheckIcon htmlColor="#0000FF" /> : null}
                </ListItemIcon>
              </ListItemButton>

              <ListItemButton
                  selected={selectedItem === "scriptConfirmAssignment"}
                  sx={{ pl: 4, fontSize:"8px" }}
                  onClick={() => { setSelectedItem("scriptConfirmAssignment");  setMenu01(false); setMenu02(false); setMenu04(false); nav("/admin/hrm/scriptConfirmAssignment"); }}
                >
                <ListItemText
                  primary={<Box sx={{fontWeight:700, fontSize:"14px"}}>할당 - 스크립트 검토</Box>}
                  // onClick={() => }
                />
                <ListItemIcon>
                  {selectedItem === "scriptConfirmAssignment" ? <CheckIcon htmlColor="#0000FF" /> : null}
                </ListItemIcon>
              </ListItemButton>

              <ListItemButton
                  selected={selectedItem === "scriptConfirmStatus"}
                  sx={{ pl: 4, fontSize:"8px" }}
                  onClick={() => { setSelectedItem("scriptConfirmStatus");  setMenu01(false); setMenu02(false); setMenu04(false); nav("/admin/hrm/scriptConfirmStatus"); }}
                >
                <ListItemText
                  primary={<Box sx={{fontWeight:700, fontSize:"14px"}}>스크립트 검토 현황</Box>}
                  // onClick={() => }
                />
                <ListItemIcon>
                  {selectedItem === "scriptConfirmStatus" ? <CheckIcon htmlColor="#0000FF" /> : null}
                </ListItemIcon>
              </ListItemButton>

              <ListItemButton
                selected={selectedItem === "cms"}
                sx={{ pl: 4 }}
                onClick={() => { setSelectedItem("cms");  setMenu01(false); setMenu02(false); setMenu04(false); nav("/admin/hrm/cms");}}
              >
                <ListItemText
                  primary={<Box sx={{fontWeight:700, fontSize:"14px"}}>신규 회원</Box>}
                  // onClick={() => }
                />
                <ListItemIcon>
                  {selectedItem === "cms" ? <CheckIcon htmlColor="#0000FF" /> : null}
                </ListItemIcon>
              
              </ListItemButton>

                {/* <ListItemButton
                  selected={selectedItem === "prcWrd"}
                  sx={{ pl: 4 }}
                  onClick={() => { setSelectedItem("prcWrd");  setMenu01(false); setMenu02(false); setMenu04(false); nav("/insight/asv/prcWrd");}}
                >
                  <ListItemText
                    primary="단어 리스트"
                    // onClick={() => }
                  />
                  <ListItemIcon>
                    {selectedItem === "prcWrd" ? <CheckIcon htmlColor="#0000FF" /> : null}
                  </ListItemIcon>
                </ListItemButton>
                <ListItemButton
                  selected={selectedItem === "파일 업로드"}
                  sx={{ pl: 4 }}
                  onClick={() => { setSelectedItem("파일 업로드");  setMenu01(false); setMenu02(false); setMenu04(false); }}
                >
                  <ListItemText primary="파일 업로드" onClick={upload_test} />
                  <ListItemIcon>
                    {selectedItem === "파일 업로드" ? <CheckIcon htmlColor="#0000FF" /> : null}
                  </ListItemIcon>
                </ListItemButton>
                <ListItemButton
                  selected={selectedItem === "파일 저장소"}
                  sx={{ pl: 4 }}
                  onClick={() => { setSelectedItem("파일 저장소");  setMenu01(false); setMenu02(false); setMenu04(false); }}
                >
                  <ListItemText primary="파일 저장소" onClick={tree} />
                  <ListItemIcon>
                    {selectedItem === "파일 저장소" ? <CheckIcon htmlColor="#0000FF" /> : null}
                  </ListItemIcon>
                </ListItemButton> */}

              </List>

            </Collapse>
          </Box>
          :""}

          {/* <MenuItem onClick={asClick}>
            <ListItemIcon>
              <FaceIcon />
            </ListItemIcon>
            <ListItemText primary="한울" />
            {open ? <ExpandLess /> : <ExpandMore />}
          </MenuItem>

          <Collapse in={asopen} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              <ListItemButton
                selected={selectedItem === "사용자 목록"}
                sx={{ pl: 4 }}
                onClick={() => { setSelectedItem("사용자 목록"); setMenu02(false); setMenu01(false); }}
              >
                <ListItemText primary="사용자 목록" onClick={goMain} />
                <ListItemIcon>
                  {selectedItem === "사용자 목록" ? <CheckIcon htmlColor="#0000FF" /> : null}
                </ListItemIcon>
              </ListItemButton>
              <ListItemButton
                selected={selectedItem === "한울 테스트"}
                sx={{ pl: 4 }}
                onClick={() => { setSelectedItem("한울 테스트"); setMenu02(false); setMenu01(false); }}
              >
                <ListItemText primary="한울 테스트" onClick={hanwool} />
                <ListItemIcon>
                  {selectedItem === "한울 테스트" ? <CheckIcon htmlColor="#0000FF" /> : null}
                </ListItemIcon>
              </ListItemButton>
              <ListItemButton
                selected={selectedItem === "울이 목록"}
                sx={{ pl: 4 }}
                onClick={() => { setSelectedItem("울이 목록"); setMenu02(false); setMenu01(false); }}
              >
                <ListItemText primary="울이 목록" onClick={wools} />
                <ListItemIcon>
                  {selectedItem === "울이 목록" ? <CheckIcon htmlColor="#0000FF" /> : null}
                </ListItemIcon>
              </ListItemButton>
              
            </List>
          </Collapse> */}
        </MenuList>
      </Box>
    </Box>
  );
};

export default MenuPage;
